import _sfc_main from './say-as-menu.vue2.js';
/* empty css                */
import _export_sfc from '../../../_virtual/_plugin-vue_export-helper.js';

const sayAsMenu = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-11ca76e0"]]);

export { sayAsMenu as default };
//# sourceMappingURL=say-as-menu.js.map
